import { gql } from '@apollo/client'

// One zone of the first-party (own drivers) delivery area. Money fields are
// GROSS cents (incl. VAT); `min_order_cents: 0` means no minimum and
// `free_above_cents: 0` means the fee never drops to free.
export const DELIVERY_ZONE_FIELDS = gql`
  fragment DeliveryZoneFields on DeliveryZone {
    id
    postcode
    fee_cents
    min_order_cents
    free_above_cents
    active
    created_at
    updated_at
  }
`

// The admin read side (delivery.view): the global switch plus ALL zones —
// paused ones included, and regardless of `enabled`, because the screen must
// be able to manage the area while delivery is switched off.
export const GET_DELIVERY_SETTINGS = gql`
  ${DELIVERY_ZONE_FIELDS}
  query DeliverySettings {
    deliverySettings {
      enabled
      zones {
        ...DeliveryZoneFields
      }
    }
  }
`
